<template>
  <a @click="triggerAction">
    <slot name="trigger">
      <MTooltip>
        <template v-slot:trigger>
          <MIcon name="eye" class="action-menu-icon" />
        </template>
        {{ $tc('view') }}
      </MTooltip>
    </slot>
    <FlotoDrawer :open="showDrawer" @hide="hideDrawer">
      <template v-slot:title>
        <slot name="title">
          {{ $tc('remarks') }}
        </slot>
      </template>
      <Conversation
        v-if="conversation"
        :id="conversation.id"
        :key="conversation.id"
        disabled
        :type="conversation.type"
        :can-edit="false"
        :can-delete="false"
        :is-private="conversation.isPrivate"
        :text="conversation.text"
        :created-at="conversation.createdAt"
        :attachments="conversation.fileAttachments"
        :owner="conversation.owner"
        :rating="conversation.rating"
        :field-value-details="conversation.fieldValueDetails"
        :subject="conversation.subject"
        :email-ids="conversation.emailIds"
        :cc-email-ids="conversation.ccEmailIds"
        use-private-indicator
        :inline-edit="false"
        :is-draft="conversation.conversationState === 'draft'"
      />
      <template v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">
          {{ $t('done') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>
<script>
import Conversation from '../conversation.vue'
import { getConversationApi } from '../api'
export default {
  name: 'ConversationViewDrawer',
  components: { Conversation },
  props: {
    conversationId: { type: Boolean, required: true },
  },
  data() {
    return {
      showDrawer: false,
    }
  },
  methods: {
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      this.getConversation()
      setTimeout(() => {
        this.showDrawer = true
      }, 400)
    },
    hideDrawer() {
      this.showDrawer = false
    },
    getConversation() {
      return getConversationApi(this.conversationId).then((data) => {
        this.conversation = data
      })
    },
  },
}
</script>
